import SelfServiceMachinePage from '@/pages/smart-device/self-service-machine'
import SelfServiceMachineDetailPage from '@/pages/smart-device/self-service-machine/detail'
import SmartLockPage from '../pages/smart-device/samrt-lock'
import SmartLockDetailPage from '../pages/smart-device/samrt-lock/detail'
import LockAccountPage from '../pages/smart-device/lock-account-manage'
import openOnline from '@/pages/smart-device/open-online'
import DictionaryManaged from '@/pages/smart-device/dictionary-managed' //字典管理

export const selfServiceMachine = {
  path: 'smart-device/list',
  component: SelfServiceMachinePage
};

export const selfServiceMachineDetail = {
  path: 'smart-device/detail',
  component: SelfServiceMachineDetailPage
};
export const smartLock = {
  path: 'smart-device/smart-lock',
  component: SmartLockPage
};
export const smartLockDetail = {
  path: 'smart-device/smart-lock-detail',
  component: SmartLockDetailPage
};
export const lockAccount = {
  path: 'smart-device/lock-account-manage',
  component: LockAccountPage
};
export const smartOpenOnline = {
  path: 'smart-device/open-online',
  component: openOnline
};
//字典管理
export const dictionaryManaged = {
  path: 'smart-device/dictionary-managed',
  component: DictionaryManaged
};


// WEBPACK FOOTER //
// ./src/router/smart-device.js